if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

/**
 * Filters product media by ALT tags such as "variant-cabana-stripe".
 * Media tagged "variant-common" or without a variant-* tag remains visible.
 */
(() => {
  const normaliseVariantTag = (value) =>
    value
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');

  const filterVariantMedia = (productInfo) => {
    const selectedPattern =
      productInfo.querySelector('input[data-option-name="Pattern"]:checked') ||
      productInfo.querySelector('select[name="options[Pattern]"]');
    if (!selectedPattern) return;

    const selectedTag = normaliseVariantTag(selectedPattern.value);
    const mediaItems = productInfo.querySelectorAll('[data-media-id]');

    mediaItems.forEach((mediaItem) => {
      const altText = Array.from(mediaItem.querySelectorAll('img[alt]'))
        .map((image) => image.alt)
        .join(' ');
      const tags = Array.from(altText.matchAll(/\bvariant-([a-z0-9-]+)\b/gi), (match) =>
        match[1].toLowerCase()
      );
      mediaItem.hidden = tags.length > 0 && !tags.includes('common') && !tags.includes(selectedTag);
    });

    productInfo.querySelectorAll('media-gallery').forEach((gallery) => {
      const activeMedia = gallery.querySelector('[data-media-id].is-active');
      if (activeMedia?.hidden) {
        const firstVisibleMedia = Array.from(
          gallery.querySelectorAll('[id^="GalleryViewer"] [data-media-id]')
        ).find((item) => !item.hidden);
        if (firstVisibleMedia) gallery.setActiveMedia?.(firstVisibleMedia.dataset.mediaId, false);
      }
      gallery.elements?.viewer?.resetPages?.();
      gallery.elements?.thumbnails?.resetPages?.();
    });
  };

  const filterAllProductMedia = () => {
    document.querySelectorAll('product-info').forEach(filterVariantMedia);
  };

  document.addEventListener('change', (event) => {
    if (
      !event.target.matches(
        'input[data-option-name="Pattern"], select[name="options[Pattern]"]'
      )
    ) return;
    [0, 300, 900].forEach((delay) => window.setTimeout(filterAllProductMedia, delay));
  });

  document.addEventListener('shopify:section:load', filterAllProductMedia);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', filterAllProductMedia);
  } else {
    filterAllProductMedia();
  }
})();
